import { lazy } from "react";

export type { IMoreMenuContainerProps } from "./types";

export const MoreMenu = lazy(() => import("./MoreMenuContainer"));
